import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core'
import { CONTENT_TYPE, SOURCE_TYPE, LANGUAGES, JUDICIAL_DOCUMENT, OUTCOME_OF_TRIAL, PHASE_OF_CASE, TYPE_OF_JUDICIAL_DOCUMENT, TYPE_OF_COURT, LEVEL_OF_CONFIDENTIALITY, IMPORTANCE, SUBJECT, PHASE_OF_PREPARATORY, BOOLEAN_OPTIONS } from '../../Features/AddNewLTDDocument/@types'
import FormGroup, { IFormConfig } from '../FormGroup'
import _ from 'lodash';
import { connect } from 'react-redux';
import { TState } from '../../RootReducer';
import { ONewLTDDocument } from '../../Features/AddNewLTDDocument/redux-config';
import { OApp } from '../../RootReducer/AppReducer';
import ChipSelect from '../ChipSelect';
import SearchAdd from '../SearchAdd';
import DragReorderList from '../DragReorderList';
import { METADATA_AUTHOR, METADATA_COPY_RIGHT_AUTHORISATION, METADATA_IMPORTANCE, METADATA_KEY_WORD, METADATA_LEVEL_OF_CONFIDENTIALITY, METADATA_PHASE_OF_PREPARATOR_WORKS, METADATA_PUBLISHER, METADATA_RESOURCE_CITATION_ENGLISH, METADATA_RESOURCE_CITATION_FRENCH, METADATA_SUBJECT, METADATA_SUBJECT_LEVEL_2, METADATA_SUBJECT_LEVEL_3, METADATA_SUBJECT_LEVEL_4 } from '../../Features/Translations/translationKeys.ltd';
import { WithTranslationProps, withTranslations } from '../../Features/Translations/withTranslations';


interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps { }


interface IStateProps {
    formData: Record<string, any>
    appConstants: any
}

interface IDispatchProps {
    setFormField: (key: string, value: any) => void
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => void,
}
class Bibliography extends Component<IProps & WithTranslationProps> {
    state = {
        list: [
        ]
    }

    componentDidMount() {
        this.setKeywordList();
    }

    componentDidUpdate(prevProps) {
        if (_.isEmpty(prevProps.formData) && !_.isEmpty(this.props.formData))
            this.setKeywordList();
    }

    setKeywordList = () => {
        const { formData } = this.props;
        this.setState({ list: (_.get(formData, 'keywords') || []).map(k => ({ name: k.title, id: k.id })) })
    }

    onReorder = (newList: any) => {
        this.setState({ list: newList });
        this.props.setFormField('keywordIds', newList.map(item => item.id));
    }


    handleChange = (e: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(e.target.name, e.target.value)
        }
    }

    handleSlect = (key: string, value: any) => {
        if (this.props.setFormField) {
            this.props.setFormField(key, value)
        }
    }


    handleSuggestion = ({ name, value }) => {
    }

    handleSuggestionSelect = ({ name, value }) => {
        const list = [...this.state.list, value]
        this.setState({ list });
        this.props.setFormField(name, list.map(item => item.id));
    }


    handleRemoveItem = (index: number) => {
        const newList = _.filter(this.state.list, (item, i) => i !== index);
        this.props.setFormField('keywordIds', newList.map(item => _.get(item, 'id')))
        this.setState({ list: newList });
    }


    render() {
        const { classes, formData, appConstants, getTranslation } = this.props

        const ADDITIONAL_CONFIG: IFormConfig[][] = _.get(formData, 'contentType') === 'academic_writing' ? [
            [
                { label: 'Subject', key: 'Subject', type: 'select', onChange: this.handleChange, options: SUBJECT, translationKey: METADATA_SUBJECT },
                { label: 'Subject (Level 2)', key: 'Subject (Level 2)', type: 'select', onChange: this.handleChange, options: SUBJECT, translationKey: METADATA_SUBJECT_LEVEL_2 },
            ],
            [
                { label: 'Subject (Level 3)', key: 'Subject (Level 3)', type: 'select', onChange: this.handleChange, options: SUBJECT, translationKey: METADATA_SUBJECT_LEVEL_3 },
                { label: 'Subject (Level 4)', key: 'Subject (Level 4)', type: 'select', onChange: this.handleChange, options: SUBJECT, translationKey: METADATA_SUBJECT_LEVEL_4 },
            ],
        ] : [];


        const FORM_CONFIG: IFormConfig[][] = [

            [
                { label: 'Author/Editor', key: 'author', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_AUTHOR },
            ],
            [
                { label: 'Publisher', key: 'publisher', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_PUBLISHER },
            ],

            [
                { label: 'Level of confidentiality', key: 'confidentiality', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'confidentiality') || [], translationKey: METADATA_LEVEL_OF_CONFIDENTIALITY },
                { label: 'Importance', key: 'importance', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'importance') || IMPORTANCE, translationKey: METADATA_IMPORTANCE },
            ],
            [
                {
                    label: '', key: 'Copyright authorisation', type: 'component', onChange: this.handleChange, component: (
                        <ChipSelect formkey="copyRightAuthorisation" value={formData['copyRightAuthorisation']} title={getTranslation(METADATA_COPY_RIGHT_AUTHORISATION) || 'Copyright authorisation'} onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                    )
                },
                {
                    label: '', key: 'Exclude from search engine indexation', type: 'component', onChange: this.handleChange, component: (
                        <ChipSelect formkey="disableIndexing" value={formData['disableIndexing']} title='Exclude from search engine indexation' onChange={this.handleSlect} options={BOOLEAN_OPTIONS} />
                    )
                },
            ],

            ...ADDITIONAL_CONFIG,

            [
                { label: 'Phase of preparatory works', key: 'preparatoryPhase', type: 'select', onChange: this.handleChange, options: _.get(appConstants, 'preparatoryPhase') || PHASE_OF_PREPARATORY, translationKey: METADATA_PHASE_OF_PREPARATOR_WORKS },
            ],
            [
                { label: 'Resource citation (English)', key: 'resourceCitation_en', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_RESOURCE_CITATION_ENGLISH },
            ],
            [
                { label: 'Resource citation (French)', key: 'resourceCitation_fr', type: 'multiline', onChange: this.handleChange, translationKey: METADATA_RESOURCE_CITATION_FRENCH },
            ],
            [
                {
                    label: 'keywords', key: 'keywords', type: 'component', onChange: this.handleChange, translationKey: METADATA_KEY_WORD, component: (
                        <div className="my-3">
                            <SearchAdd
                                objectValue
                                disableAdd

                                searchKey='keywords'
                                label={getTranslation(METADATA_KEY_WORD) || "Keywords"}
                                formKey="keywordIds"
                                key="keywordIds"
                                onSelect={this.handleSuggestionSelect}
                                onChange={this.handleSuggestion}
                                suggestionUrl="ltdkeywords/autocomplete"
                                params={(val) => ({ term: val, field: 'title' })}
                                handleSuggestions={(data) => data.map(val => ({ name: val['title'], id: val['id'] }))}
                            />
                            <DragReorderList
                                id="keywords"
                                list={this.state.list}
                                onReorder={this.onReorder}
                                onRemove={this.handleRemoveItem}
                            />
                        </div>
                    )
                }
            ],
            [
                { label: 'IfRI-Internal', key: 'ifri_internal', type: 'multiline', onChange: this.handleChange },
            ],


        ]

        return (
            <>
                <FormGroup classes={{ root: classes.formContainer }} formData={formData} formItems={FORM_CONFIG} />
            </>
        )
    }
}

const STYLES = (theme: Theme) => createStyles({
    formContainer: {
        [theme.breakpoints.down('sm')]: {
            width: '95vw',
        }
    }
})
const mapStateToProps = (state: TState): IStateProps => ({
    ..._.pick(state.NewLTDDocument, ['formData']),
    appConstants: _.get(state.App, 'appConstants.LtdDoc')
});

const mapDispatchToProps = (dispatch): IDispatchProps => ({
    setFormField: (k: string, v: any) => dispatch(ONewLTDDocument.setFormField(k, v)),
    confirmationDialog: (msg: string, onConfirm: Function, onCancel: Function) => dispatch(OApp.showConfirmationDialog(msg, onConfirm, onCancel)),

})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(withTranslations(Bibliography)))